import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";

const values = [1, 2, 3, 4, 5, 7, 10, 14, 21, 30] as const;
type AttributionFilterValue = (typeof values)[number];
const attributionFilterOptions: RedoListItem<AttributionFilterValue>[] =
  values.map((value) => ({
    id: value,
    type: "text",
    text: `${value} days`,
    value,
  }));

export const MarketingAttributionFilter = memo(
  function MarketingAttributionFilter({
    attributionFilter,
    setAttributionFilter,
  }: {
    attributionFilter: number;
    setAttributionFilter: (value: number) => void;
  }) {
    return (
      <RedoSingleSelectDropdownInput
        fitToAnchor={false}
        flexGrow={false}
        label="Attribution"
        options={attributionFilterOptions}
        optionSelected={({ item }) => setAttributionFilter(item.value)}
        selectedItem={attributionFilterOptions.find(
          (option) => option.value === attributionFilter,
        )}
        size="xs"
      />
    );
  },
);
